import { render, staticRenderFns } from "./tc-player.vue?vue&type=template&id=5acd5c9f"
import script from "./tc-player.vue?vue&type=script&lang=js"
export * from "./tc-player.vue?vue&type=script&lang=js"
import style0 from "./tc-player.vue?vue&type=style&index=0&id=5acd5c9f&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acd5c9f')) {
      api.createRecord('5acd5c9f', component.options)
    } else {
      api.reload('5acd5c9f', component.options)
    }
    module.hot.accept("./tc-player.vue?vue&type=template&id=5acd5c9f", function () {
      api.rerender('5acd5c9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tc-player.vue"
export default component.exports